<template>
  <div>
    <identity-verification-form
      :form-model="formModel"
      :person-title="local.bankruptcy.debtorForm.debtor"
      :view-mode="loading"
      :is-table-data="isTableData"
    ></identity-verification-form>
  </div>
</template>
<script>

import IdentityVerificationForm from '@/modules/bankruptcy/components/request/identity-verification-form.vue';

export default {
  name: 'DebtorForm',
  inject: ['$validator'],
  components: { IdentityVerificationForm },
  props: {
    formModel: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    isTableData:{
      type: Boolean,
      required: false,
      default: false,
    },
    loading: {
      type: Boolean,
      required: true,
      default: () => false,
    },
  },
  data() {
    return {};
  },
  computed: {},
  created() {
  },
  methods: {},
};
</script>

<style lang="scss">
</style>
